<div class="flex items-center justify-center dialog-header ">
    Call to {{communicationData?.first_name}} {{communicationData?.last_name}}

    <div class="absolute right-2">
        <button (click)="handleCloseCallDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>
<div class="dialog-content">
    <div>
        <form [formGroup]="phoneForm" (ngSubmit)="onProceed()" style="width: 100%; height: 213px; margin-top: 10px;">
            <div style="font-weight: 600; margin-top: -13px; margin-bottom: 5px;">
                Contact Number
            </div>
            <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="['in']" [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true" [searchCountryFlag]="true" (keyup.enter)="onProceed()"
                [selectFirstCountry]="true" [formControlName]="'phone'" [maxLength]="15">
            </ngx-intl-tel-input>

            <div *ngIf="!phoneForm.valid">
                <div class="invalid-phone-text">Please enter a valid phone number</div>
            </div>

            <div class="flex flex-col gap-5 mt-6">
                <div>
                    <span class="font-semibold text-md">Name:</span>
                    <span class="ml-1">{{ getFullName() }}</span>
                </div>

                <div>
                    <span class="font-semibold">Gender:</span>
                    <span class="ml-1">{{ communicationData?.gender }}</span>
                </div>

                <div>
                    <span class="font-semibold">Email:</span>
                    <span class="ml-1">{{ communicationData?.email }}</span>
                </div>
            </div>

        </form>
    </div>
    <div class="flex justify-end  mt-4">
        <p-button *ngIf="!isDialerReady" label="Proceed" icon="pi pi-phone"
        
        class="flex justify-end"
            (click)="onProceed()"></p-button>
        <p-button label="Call" icon="pi pi-phone"
         severity="danger" *ngIf="isDialerReady" class="flex justify-end"
            (click)="onProceed()"></p-button>

    </div>
</div>


<p-dialog [modal]="true" [(visible)]="isOpenNotesModal" appendTo="body"
[breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <app-communication-note (closeDialog)="handleCloseAllDialogs()"
    [communicationData]="communicationData"
    [hangUpCallData]="hangUpCallData"
    [timeWhenCallStarted]="timeWhenCallStarted"
    ></app-communication-note>
</p-dialog>
